import Modal from 'react-modal'
import LoginForm from '../login/LoginForm'
import '../login/sass/app.scss'
import './login-popup.scss'

export default function LoginPopup({ isOpen, closeModal }) {
  const onSubmitSuccess = () => window.location.reload()
  return (<Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    ariaHideApp={false}
    className='Modal react-popup form-popup login-popup'
    overlayClassName='Overlay'
    contentLabel='Booking enquire popup'>
    <span className='close-btn' onClick={closeModal} />
    <div className='forms-wrapper'>
      <LoginForm hidePasswordRestore onSubmitSuccess={onSubmitSuccess} />
    </div>
  </Modal>)
}
